import api from './api';

export type KpiStatus = 'COMPUTED' | 'UNAVAILABLE';

export type KpiCategory =
  | 'Aquisição'
  | 'Produto'
  | 'Engajamento'
  | 'Conversão Potencial'
  | 'Qualidade do Tráfego';

export interface KpiValue {
  key: string;
  category: KpiCategory;
  label: string;
  definition: string;
  usage: string;
  status: KpiStatus;
  value: number | null;
  display: string;
  unit?: 'count' | 'percent' | 'days' | 'avg';
  unavailableReason?: string;
}

export interface ProductKpisReport {
  generatedAt: string;
  range: { startDate: string | null; endDate: string | null };
  productId: number | null;
  totalUsers: number;
  validUsers: number;
  kpis: KpiValue[];
}

export interface ReportParams {
  productId?: number;
  startDate?: string;
  endDate?: string;
}

export const productKpisService = {
  getReport: (params?: ReportParams) =>
    api
      .get<{ success: boolean; data: ProductKpisReport }>('/docugen-report/kpis', { params })
      .then((r) => r.data.data),
};
